import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";
import ApiService from "@/api/ApiService";
import { useGlobalStore, usePersistantStore } from "@/stores/global";
import dayjs from "dayjs";
import TransferContainer from "@/components/calendar/TransferContainer";

export default function Transfers() {
  const navigate = useNavigate();
  const region = usePersistantStore((store) => store.region);
  const setDate = useGlobalStore((state) => state.setDate);
  const setKgpReference = usePersistantStore((state) => state.setKgpReference);

  const currentDate = dayjs().format("YYYY-MM-DD");

  const setCalendar = (_newType: string, reference: number, date: dayjs.ConfigType) => {
    setDate(dayjs(date));
    setKgpReference(reference);
    navigate("/kgp");
  };

  const query = useQuery<unknown[], AxiosResponse>({
    queryKey: ["getTransfers", "" + (region || 0), currentDate],
    enabled: !!currentDate,
    queryFn: ApiService.getDailyTransfers(region || 0, currentDate),
  });

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        overflow: "auto",
        flexDirection: "column",
      }}
    >
      <TransferContainer query={query} setCalendar={setCalendar} />
    </div>
  );
}
